import React, { useEffect, useState } from "react";
import styles from "../assets/scss/pages.module.scss";
import ArtworkCard from "components/cards/artworkCard/ArtworkCard";
import paintingImage1 from "../assets/images/paintings/painting1.png";
import paintingImage2 from "../assets/images/paintings/painting2.png";
import paintingImage3 from "../assets/images/paintings/painting3.png";
import HeartIcon from "components/svgs/HeartIcon";
import ShareIcon from "components/svgs/ShareIcon";
import ReactImageGallery from "react-image-gallery";
import BagIcon from "components/svgs/BagIcon";
import { paintings } from "mockdata/paintings";

const images = [
  {
    original: paintingImage1,
    thumbnail: paintingImage1,
  },
  {
    original: paintingImage2,
    thumbnail: paintingImage2,
  },
  {
    original: paintingImage3,
    thumbnail: paintingImage3,
  },
];

const SinglePaintingPage = () => {
  const [thumbnailPosition, setThumbnailPosition] = useState("left");
  const [liked, setLiked] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const updateThumbnailPosition = () => {
      if (window.innerWidth < 768) {
        setThumbnailPosition("bottom");
        const thumbnailWrapper = document.querySelector(
          ".image-gallery-thumbnails-wrapper"
        );
        if (thumbnailWrapper) {
          thumbnailWrapper.style.maxWidth = window.outerWidth - 40 + "px";
        }
      } else {
        setThumbnailPosition("left");
      }
    };

    updateThumbnailPosition();
    window.addEventListener("resize", updateThumbnailPosition);

    return () => window.removeEventListener("resize", updateThumbnailPosition);
  }, []);
  return (
    <div className={styles.singlePaintingPage}>
      <div className="container">
        <div className={styles.paintingDetailsSection}>
          <div className={styles.paintingImages}>
            <ReactImageGallery
              items={images}
              thumbnailPosition={thumbnailPosition}
              showFullscreenButton={false}
              showPlayButton={false}
              showBullets={false}
              showNav={false}
              additionalClass="singlePaintingImages"
            />
            <div className={styles.addToBasketBtn}>
              <button>
                ADD TO BASKET <BagIcon />
              </button>
            </div>
          </div>
          <div className={styles.paintingInfo}>
            <div className={styles.dateAndShare}>
              <div className={styles.date}>2023</div>
              <div className={styles.share}>
                <div
                  className={`${styles.heartIcon} ${liked ? styles.liked : ""}`}
                  title="Like"
                  onClick={(e) => {
                    e.stopPropagation();
                    setLiked(!liked);
                  }}
                >
                  <HeartIcon />
                </div>
                <ShareIcon />
              </div>
            </div>
            <div className={styles.paintingName}>Name Of The Painting</div>
            <div className={styles.artistName}>Name Lastname</div>
            <div className={styles.divider} />
            <div className={styles.sizePriceContainer}>
              <div>Acrylic, Collage on Canvas</div>
              <div>90x90 cm</div>
              <div className={styles.price}>$ 10.000</div>
            </div>
            <div className={styles.divider} />
            <div className={styles.shippingContainer}>
              <div>
                Shipping from: <span>Armenia</span>
              </div>
              <div>
                Calculate shipping cost:{" "}
                <span className={styles.calc}>Calculate</span>
              </div>
            </div>
            <div className={styles.divider} />
            <div className={styles.otherInfos}>
              <div>
                <span>Framed</span> |{" "}
                <span className={styles.orderFrame}>Order a Frame</span>
              </div>
              <div>
                <span>Signed By The Artist</span>
              </div>
              <div>
                Certificate of Authenticity: <span>Available</span>
              </div>
              <div>
                Status: <span>Original</span>
              </div>
              <div>
                <span>Unique</span>
              </div>
            </div>
            <div className={styles.divider} />
            <div className={styles.descriptionSection}>
              <div className={styles.descTitle}>About The Painting</div>
              <div className={styles.paintingDesc}>
                Lorem Ipsum is not simply random text. It has roots in a
                piece-Sydney College in Virginia, looked up one of the more
                obscure Latin words, consectetur, from a Lorem Ipsum passage,
                and going throug
              </div>
            </div>
            <div className={styles.divider} />
            <div className={styles.actions}>
              <div>Purchase Terms</div>
              <div>Return Policy</div>
              <div>Guarantee</div>
              <div>Estimated Delivery Time</div>
            </div>
          </div>
        </div>
        <div className={styles.otherArtworks}>
          <h2 className={styles.title}>Other Artworks By Name Lastneme</h2>
          <div className={styles.paintingList}>
            {paintings.map((painting) => {
              return <ArtworkCard item={painting} key={painting.id} />;
            })}
          </div>
          <div className={styles.loadMore}>
            <button>Load More</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SinglePaintingPage;
